module.exports = __webpack_public_path__ + "img/logo100_text.f0ffcef0.png";